import { RoleEntity } from '@data';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import type { IError, ListResponse } from '../utils/types';
import * as api from '../api';
import * as queryKeys from '../constants/keys';

export const useListRoles = (params: {
  userId: string;
  productId: string;
}): UseQueryResult<ListResponse<RoleEntity>, IError> =>
  useQuery({
    queryKey: [queryKeys.ROLES, params],
    queryFn: () => api.fetchRoles(params),
    enabled: !!params.productId && !!params.userId,
  });
